import React from 'react'
import styled from 'styled-components'

const Svg = styled.svg`
  stroke-width: 40;
  stroke: #000;
  fill: none;
  position: absolute;
  width: 130%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  opacity: 0.05;
`

export default () => (
  <Svg className="about-bg-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 393.4 195">
    <polyline points="7.5 110.9 206.9 14.9 206.9 75.8 378.9 133 378.9 192"/>
  </Svg>
)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/pages/about/AboutBGSVG.js